export const darkTheme = {
  bg: "#a2bdbc",
  bgLight: "#1C1E27",
  primary: "#854CE6",
  text_primary: "#111212",
  text_secondary: "#041c63",
  card: "#e1ebea",
  card_light: "#0ec2eb",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFFF",
  bgLight: "#f0f0f0",
  primary: "#be1adb",
  text_primary: "#111111",
  text_secondary: "#48494a",
  card: "#FFFFFF",
  button: "#5c5b5b",
};
